<template>
  <div>
    <h1>
      Volunteer - Edit - {{ volunteerData.location.name }} on
      {{ volunteerData.location.dateCreated }}
    </h1>

    <b-form-group
      horizontal
      label="Name:"
      label-size="lg"
      label-for="txtVolunteerName"
    >
      <b-form-input
        type="text"
        v-model="volunteerData.volunteer.name"
      ></b-form-input>
    </b-form-group>

    <div>
      <label>Code:</label>
      <label>{{ volunteerData.volunteer.pinCode }}</label>
    </div>

    <b-button size="lg" @click="submit">Save</b-button>&nbsp;
    <b-button
      size="lg"
      tag="button"
      :to="{ name: 'volunteers', params: { id: $route.params.locId } }"
      >Cancel</b-button
    >
  </div>
</template>

<script>
export default {
  name: "editVolunteer",
  data: () => ({
    volunteerData: {
      location: {},
      volunteer: {}
    }
  }),
  methods: {
    loadVolunteerData(volId, locId) {
      this.axios
        .get(
          process.env.VUE_APP_API_URL + "surveys/search/" + volId + "/" + locId
        )
        .then(response => (this.volunteerData = response.data))
        .catch(error => console.log(error));
    },
    submit() {
      this.axios
        .post(
          process.env.VUE_APP_API_URL + "volunteers/",
          this.volunteerData.volunteer
        )
        .then(() => console.log("sucess"))
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadVolunteerData(this.$route.params.volId, this.$route.params.locId);
  }
};
</script>
